
import Webapp from "@/pages/Webapp";
import Kolkin from "@/views/Kolkin";
import PurchaseProduct from "@/views/payment/PurchaseProduct";
import SOSListPricing from "@/views/payment/SOSListPricing";
var routes = [


	{
		name: "purchase-product",
		path: "/purchase/:product",
		component: PurchaseProduct,
	},

	{
		path: "/",
		component: Webapp,
		children: [
			{
				path: "",
				name: "kolkin",
				component: Kolkin
			},


			{
				name: "pricing",
				path: "pricing",
				component: SOSListPricing
			},


			{
				name: "invoice-page",
				path: "invoice/:number",
				component: () => import("@/views/invoice/InvoicePage")
			},

			{
				name: "invoice-payment",
				path: "pay/invoice/:number",
				component: () => import("@/views/invoice/PayInvoice")
			},

			{
				name: "license-invoice",
				path: "invoice/license/:license",
				component: () => import("@/views/license/LicenseInvoice")
			},

			// {
			// 	name: "search",
			// 	path: "search/:query?",
			// 	component: () => import(/* webpackChunkName: 'blog' */ "@/views/blog/Search")
			// },

			// {
			// 	name: "blog",
			// 	path: "blog/:category?",
			// 	component: () => import(/* webpackChunkName: 'blog' */ "@/views/blog/Blog"),
			// 	meta: {
			// 		hasSubNav: true,
			// 	}
			// },

			// {
			// 	name: "blog-article",
			// 	path: "article/:category/:slug",
			// 	component: () => import(/* webpackChunkName: 'blog' */ "@/views/blog/BlogArticle")
			// },

			// {
			// 	name: "help",
			// 	path: "docs/:category?",
			// 	alias: "help/:category?",
			// 	component: () => import(/* webpackChunkName: 'blog' */ "@/views/help/Help")
			// },

			// {
			// 	name: "help-article",
			// 	path: "docs/:category/:slug",
			// 	alias: "tutorial/:category/:slug",
			// 	component: () => import(/* webpackChunkName: 'blog' */ "@/views/help/HelpArticle")
			// },

			// {
			// 	name: "templates",
			// 	path: "templates",
			// 	component: () => import(/* webpackChunkName: 'blog' */ "@/views/sosTemplates/Templates"),
			// },

			// {
			// 	name: "sos-template-article",
			// 	path: "template/:category/:slug",
			// 	component: () => import(/* webpackChunkName: 'blog' */ "@/views/sosTemplates/SosTemplateArticle")
			// },

			// {
			// 	name: "downloads",
			// 	path: "downloads/:auto?",
			// 	alias: "download/:auto?",
			// 	component: () => import("@/views/Download")
			// },


			{
				path: "contact",
				name: "contact",
				component: () => import("@/views/ContactPage")
			},




			{
				name: "payment-confirm",
				path: "pay/success/:key?/:is_trial?",
				component: () => import("@/views/payment/PaymentConfirm")
			},

			{
				name: "expired-link",
				path: "expired/link:next?",
				component: () => import("@/views/signin/ExpiredLink")
			},

			{
				path: "/",
				component: () => import(/* webpackChunkName: 'license' */ "@/views/license/LicensesInvoices"),
				children: [
					{
						name: "licenses",
						path: "licenses/:license?",
						component: () => import(/* webpackChunkName: 'license' */ "@/views/license/LicensesMenu")
					},
					{
						name: "invoices",
						path: "invoices/",
						component: () => import(/* webpackChunkName: 'license' */ "@/views/invoice/Invoices")
					},
				]
			},


		]
	},

]
export default routes;
